import { useState } from 'react'

import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon'
import { useClipboard } from 'use-clipboard-copy'

import { Input } from '@tribeplatform/react-ui-kit/Input'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import { SocialShareButtons } from './SocialShareButtons'

export type ShareLinkType = {
  url: string
  title: string
  isPrivate: boolean
}

export const ShareLink = ({ url, title, isPrivate }) => {
  const [copied, setCopied] = useState(false)
  const clipboard = useClipboard()
  return (
    <div className="flex flex-col space-y-5">
      <Input
        onClick={e => e.currentTarget.select()}
        value={url}
        readOnly
        trailingAddon={
          <Link
            onClick={() => {
              clipboard.copy(url)
              setCopied(true)
              setTimeout(() => setCopied(false), 2000)
            }}
            variant="neutral"
          >
            {copied ? 'Copied' : 'Copy'}
          </Link>
        }
      />
      {isPrivate && (
        <div className="bg-surface-100 rounded-md p-3 flex text-sm">
          <LockClosedIcon className="flex-shrink-0 w-5 h-5 mr-2 inline-block" />
          <span>
            <strong>This page is private</strong>, so only members with enough
            permission will be able to access it.
          </span>
        </div>
      )}
      {!isPrivate && <SocialShareButtons url={url} title={title} />}
    </div>
  )
}
